var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwHideBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l12 12a1 1 0 0 0 1.414-1.414l-12-12zM1 9s.9-1.566 2.555-2.945l2.058 2.058a3.5 3.5 0 0 0 4.273 4.273l1.24 1.24A7.563 7.563 0 0 1 8.794 14C3.872 14 1 9 1 9zm8 2.5A2.5 2.5 0 0 1 6.5 9L9 11.5zm0-5L11.5 9A2.5 2.5 0 0 0 9 6.5zM12.5 9c0 .306-.04.603-.113.887l1.952 1.952C16.024 10.487 17 9 17 9s-3.282-5-8.205-5c-.714 0-1.385.105-2.01.285l1.328 1.328A3.5 3.5 0 0 1 12.5 9z",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwHideBlack);
export default __webpack_public_path__ + "static/media/pw_hide_black.e5dd85914feaffdee846a135dc3707ca.svg";
export { ForwardRef as ReactComponent };